import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { startSetDataTable } from '../actions/globalState';
import {Select} from 'antd';
import { makeDataTables} from '../utils/utils';
import { Menu, Dropdown, Button, Icon, message } from 'antd';

const Option = Select.Option;
const SubMenu = Menu.SubMenu;

export class TableDropdownType extends React.Component {
  state = {
    visible: false
  };
  static propTypes = {
    data_table: PropTypes.object,
    data_tables: PropTypes.array,
  };
  handleVisibleChange = (flag) => {
    //console.log('flag', flag);
    this.setState({ visible: flag });
  }

   handleClick = (e) => {
    //console.log('click TableDropdownType', e.item.props);
    const data_table = {
      display_name: e.item.props.title,
      table_ending: e.item.props.value,
      table_group: e.item.props.group,
      chart_order_clause: e.item.props.chart_order_clause,
      chart_heading: e.item.props.chart_heading,
      about_text: e.item.props.about_text,
      summary_heading: e.item.props.summary_heading,
      summary_content: e.item.props.summary_content,
      summary_sort: e.item.props.summary,
      show_table_comparisons: e.item.props.show_table_comparisons,
      show_table_percentage: e.item.props.show_table_percentage,
      show_tab_summary: e.item.props.show_tab_summary,
      show_tab_chart: e.item.props.show_tab_chart,
      show_tab_table: e.item.props.show_tab_table,
      show_tab_about: e.item.props.show_tab_about,
    }
    this.props.startSetDataTable(data_table);
  } 

  getMenu = () => {
    //console.log('TableDropdownType data', this.props.data_tables)
    const data = makeDataTables(this.props.data_tables);    
    const menu = (
      <Menu onClick={this.handleClick}>
      {data.map((item, index) => {
        return <SubMenu title={item.title}  key={index} >
              {item.children.map((subItem, subIndex) => {
                return <Menu.Item key={subIndex} title={subItem.title} 
                value={subItem.value} group={subItem.group} 
                chart_heading={subItem.chart_heading} 
                chart_order_clause={subItem.chart_order_clause}
                about_text={subItem.about_text}
                summary_content={subItem.summary_content}
                summary_heading={subItem.summary_heading}
                summary_sort={subItem.summary_sort ? 1 : 0}
                show_table_comparisons = {subItem.show_table_comparisons ? 1 : 0}
                show_table_percentage = {subItem.show_table_percentage ? 1 : 0}
                show_table_comparisons = {subItem.show_table_comparisons ? 1 : 0}
                show_table_percentage = {subItem.show_table_percentage ? 1 : 0}
                show_table_comparisons = {subItem.show_table_comparisons ? 1 : 0}
                show_table_percentage = {subItem.show_table_percentage ? 1 : 0}
                show_tab_summary= {subItem.show_tab_summary ? 1 : 0}
                show_tab_chart= {subItem.show_tab_chart ? 1 : 0}
                show_tab_table= {subItem.show_tab_table ? 1 : 0}
                show_tab_about= {subItem.show_tab_about ? 1 : 0}
                >{subItem.title}
                </Menu.Item>
              })}
          </SubMenu>
      })}
    </Menu>
    );
    return menu;
  }
  render() {
    
    //console.log('TableDropdownType', this.props)
    return (
      <Dropdown  overlay={this.getMenu()}
      onVisibleChange={this.handleVisibleChange}
      visible={this.state.visible}
    >
      <Button size="large">
        {this.props.data_table !== undefined && this.props.data_table.display_name} <Icon type="down" />
      </Button>
    </Dropdown>
    )
  }
}

const mapStateToProps = (state) => ({
  data_table: state.globalState.data_table,
  data_tables: state.globalState.data_tables
});

const mapDispatchToProps = (dispatch) => ({
  startSetDataTable: (text) => dispatch(startSetDataTable(text))
});

export default connect(mapStateToProps, mapDispatchToProps)(TableDropdownType);


// WEBPACK FOOTER //
// ./src/components/TableDropdownType.js